import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Spacer, TabMenu } from "@qivia/ui";
import { OperationsLimits } from "./operationsLimits";

export const Operations = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("history");

  const tabs = [
    { name: "history", title: t("appV2.operations.tabs.history") },
    { name: "limits", title: t("appV2.operations.tabs.limits") },
  ];

  return (
    <>
      <Spacer y={1} />
      <TabMenu
        tabs={tabs}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <Spacer y={1.5} />
      {selectedTab === "limits" && <OperationsLimits />}
    </>
  );
};
